import React, { FC } from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import PostShowContainer from 'buyside/components/presentation/PostShow/postShowContainer';

const PostShowPageRoot: FC<{ postId: string }> = ({ postId }) => {
  if (!postId) return;

  return (
    <ErrorBoundary pageName="the post page">
      <PostShowContainer postId={postId} />
    </ErrorBoundary>
  );
};

export default PostShowPageRoot;
